import { useEffect, useRef } from "react";
import gsap from "gsap";
import * as StyledAccordion from "./Styled.Accordion";
import * as StyledTypography from "@/styles/Styled.Typography";

const AccordionContact = ({ title, id, content, expanded, setExpanded }) => {
  const isOpen = id === expanded;
  const ref = useRef();
  const containerRef = useRef(null);
  const contentRef = useRef(null);
  const arrowRef = useRef(null);
  const titleRef = useRef(null);

  useEffect(() => {
    const content = contentRef.current;
    if (!content) return;

    gsap.killTweensOf(content);

    // animate height from current height to scrollHeight
    if (isOpen) {
      gsap.set(content, { height: "auto" });
      const fullHeight = content.scrollHeight;
      gsap.fromTo(
        content,
        { height: 0 },
        {
          height: fullHeight,
          duration: 0.5,
          ease: "power3.inOut",
        }
      );
    } else {
      gsap.to(content, {
        height: 0,
        duration: 0.5,
        ease: "power3.inOut",
      });
    }

    gsap.to(arrowRef.current, {
      rotate: isOpen ? 90 : 0,
      color: isOpen ? "#353839" : "",
      duration: 0.5,
      ease: "power3.inOut",
    });

    gsap.to(titleRef.current, {
      color: isOpen ? "#353839" : "",
      duration: 0.5,
      ease: "power3.inOut",
    });
  }, [isOpen]);

  return (
    <StyledAccordion.ContactFaqItem ref={containerRef}>
      <StyledAccordion.ContactFaqItemHeader
        onClick={() => setExpanded(id === expanded ? -1 : id)}
      >
        <StyledTypography.TypoBody1 as="h3" ref={titleRef}>
          {title}
        </StyledTypography.TypoBody1>
        {/* <h3>{title}</h3> */}
        <svg
          ref={arrowRef}
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={4}
            d="M15 19l-7-7 7-7"
          />
        </svg>
      </StyledAccordion.ContactFaqItemHeader>
      <StyledAccordion.ContactFaqItemContentWrapper
        ref={contentRef}
        style={{
          overflow: "hidden",
          height: 0,
        }}
      >
        <StyledAccordion.ContactFaqItemContent data-animate="fade-up">
          <StyledTypography.TypoBody2>{content}</StyledTypography.TypoBody2>
        </StyledAccordion.ContactFaqItemContent>
      </StyledAccordion.ContactFaqItemContentWrapper>
    </StyledAccordion.ContactFaqItem>
  );
};

export default AccordionContact;
